import React from 'react';
import './SupportSection.scss';

const SupportSection = ({ support, translation, viewAllRedirection,total }) => {
    const parseTitle = (title) => {
        const parts = (title || '').split(/(<em>.*?<\/em>)/g);
        return parts.map((part, index) =>
            part.startsWith("<em>") ? (
                <span key={index}>
                {part.replace(/<\/?em>/g, "")}
            </span>
            ) : (
                part
            )
        );
    };
    if (!support || support.length === 0) return null;
    return (
        <div style={{ marginTop: '15px' }}>
            <h4>{translation('support')}({total})</h4>
            <ul>
                {support.map((item, index) => (
                    <li key={index} className="support">
                        <a className="support" href={item.url}>
                            {parseTitle(item.title?.replace(/&amp;/g, '&'))}
                        </a>
                    </li>
                ))}
            </ul>
            <button
                className="view-all-support"
                onClick={() => viewAllRedirection('support')}
            >
                {translation('view_all_results')} >
            </button>
        </div>
    );
};

export default SupportSection;
